import Common from "../../../Common";

export interface UserCallBlockBody {
	pbx_user_id: id,
	callblock_id: id
}

export interface UserCallBlock {
	id: id
	pbx_company_id: id
	pbx_user_id: id
	active: "1" | "0"
	name: string
	type: string
}

const UserCallBlock = class extends Common {
	browseUsers = (companyId: id): CustomResponse<UserCallBlock[]> =>
		this.get(`/company/${companyId}/pbx/usercallblock/browseusers`);

	read = (companyId: id, userId: id) =>
		this.get(`/company/${companyId}/pbx/usercallblock/${userId}`);

	create = (companyId: id, data: UserCallBlockBody) =>
		this.post(`/company/${companyId}/pbx/usercallblock`, data);

	delete = (companyId: id, userId: id, id: id) =>
		this.doDelete(`/company/${companyId}/pbx/usercallblock/${id}/${userId}`);
}

export default UserCallBlock
